var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AboutHeader'),_vm._m(0),_c('AboutMain',{attrs:{"isAuthenticated":_vm.isAuthenticated}}),_vm._m(1),_c('AboutFooter')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-wrapper"},[_c('hr',{staticClass:"line"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-wrapper"},[_c('hr',{staticClass:"line"})])
}]

export { render, staticRenderFns }